import { useEffect, useState } from 'react'
import { get, post } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import { FaMinus, FaPlus } from "react-icons/fa6";
import { WaterTrackerUnits } from '../../../Utility/water_tracker_units';
import './DailyWater.css'

function DailyWater({ currentUser }) {
    const [waterConsumption, setWaterConsumption] = useState(0)
    const [waterConsumptionUnit, setWaterConsumptionUnit] = useState()
    const [userGoal, setUserGoal] = useState()
    const date = yyyy_mm_dd_date_format({})

    useEffect(() => {
        // get water consumption unit and goal
        get_water_consumption_unit_goal()
        // Today's water consumption
        get_water_consumption()
    }, [waterConsumptionUnit])

    async function get_water_consumption_unit_goal() {
        try {
            const result = await get("/api/water/get-user-water-unit-goal", {
                user_id: currentUser.uid
            })

            setWaterConsumptionUnit(result.water_unit)
            if (result.daily_water_goal)
                setUserGoal(result.daily_water_goal)
            else {
                if (result.water_unit === 'cup')
                    setUserGoal(13)
                else if (result.water_unit === 'mL')
                    setUserGoal(3075)
                else
                    setUserGoal(104)
            }
        } catch (error) {
            console.log(error)
        }
    }

    async function get_water_consumption() {
        try {
            const userWaterConsumption = await get("/api/water/get-user-water-consumption", {
                user_id: currentUser.uid,
                date: date
            })
            if (userWaterConsumption) {
                setWaterConsumption(userWaterConsumption.amount)
            }
        } catch (error) {
            console.log(error)
        }
    }

    async function set_water_tracker(amount) {
        try {
            if (amount < 0)
                amount = 0
            else if (amount > 9999)
                amount = 9999

            if (amount !== 0 || parseFloat(waterConsumption) > 0) {
                const result = await post("/api/water/set-user-water-consumption", {
                    user_id: currentUser.uid,
                    amount: amount,
                    unit: waterConsumptionUnit,
                    date: date
                })

                setWaterConsumption(result.amount)
            }
        } catch (e) {
            console.log(`Error in setting water consumption: ${e.message}`)
        }
    }

    async function setWaterUnit(e) {
        const value = e.target.value
        const result = await post("/api/water/set-user-water-unit", {
            user_id: currentUser.uid,
            unit: value
        })

        setWaterConsumptionUnit(result.unit)
    }


    return (
        <div className="component_padding black height_100">
            <div className='component_full_height flex justify_space_between align_center'>
                <div className='water-tracker-parent'>
                    <h4 className='font_family_ovo no_margin'>Water Tracker</h4>

                    {/* <span className='water-tracker-mobile-parent-display'> */}
                    <div className="dashboard-water-consumption-chart-circle-container water-tracker-mobile-display">
                        <svg width="230" height="230" viewBox="0 0 200 200">
                            <circle className="dashboard-water-consumption-chart-outer-circle" cx="100" cy="100" r="90" />
                            <circle className="dashboard-water-consumption-chart-inner-circle" cx="100" cy="100" r="90" stroke-dasharray="565"
                                stroke-dashoffset={565 - 565 * parseFloat(parseFloat(waterConsumption) / parseFloat(userGoal)) <= 0 ?
                                    0 : (565 - 565 * parseFloat(parseFloat(waterConsumption) / parseFloat(userGoal)))
                                } />
                        </svg>
                        <div className="dashboard-water-consumption-chart-text text_align_center">
                            <input type="number" value={parseInt(waterConsumption)}
                                onChange={(e) => set_water_tracker(!e.target.value || e.target.value < 0 ? 0 : e.target.value)}
                                style={{ width: `${parseInt(waterConsumption).toString().length}ch` }}
                                className='dashboard-water-consumption-chart-inner-circle-input font_family_ovo no_margin' />
                            <p className='no_margin gray_scale_3 font_weight_600'>{'/ ' + userGoal + ' ' + waterConsumptionUnit}</p>
                        </div>
                    </div>

                    <div className='flex flex_column gap_20'>
                        <p className='no_margin gray_scale_3 font_weight_600'>Enter Your Water-Intake</p>
                        <div className='dashboard-water-consumption-input-amount-all-div flex align_center justify_space_between'>
                            <div className='dashboard-water-consumption-input-amount-plus-minus flex align_center justify_center'
                                onClick={() => set_water_tracker(parseInt(waterConsumption) - 5)}>
                                <FaMinus size={18} />
                            </div>
                            <div className='dashboard-water-consumption-input-amount gray_scale_2 font_weight_600 font_size_16'>
                                <p>{parseInt(waterConsumption)} {waterConsumptionUnit}</p>
                            </div>
                            <div className='dashboard-water-consumption-input-amount-plus-minus flex align_center justify_center'
                                onClick={() => set_water_tracker(parseInt(waterConsumption) + 5)}>
                                <FaPlus size={18} />
                            </div>
                        </div>
                        <select onChange={setWaterUnit} className='dashboard-water-consumption-unit-select cursor_pointer gray_gradient font_size_14 font_weight_600'>

                            {Object.entries(WaterTrackerUnits).map(([key, value]) => (
                                <option key={key} value={value} selected={waterConsumptionUnit === value}>{key}</option>
                            ))}
                            {/* <option value='oz' selected={waterConsumptionUnit === 'oz'}>OZ</option>
                            <option value='mL' selected={waterConsumptionUnit === 'mL'}>mL</option> */}

                        </select>
                    </div>
                </div>


                {/* Water Tracker Full Window */}
                <div class="dashboard-water-consumption-chart-circle-container water-tracker-full-window-display">
                    <svg width="230" height="230" viewBox="0 0 200 200">
                        <circle class="dashboard-water-consumption-chart-outer-circle" cx="100" cy="100" r="90" />
                        <circle class="dashboard-water-consumption-chart-inner-circle" cx="100" cy="100" r="90" stroke-dasharray="565"
                            stroke-dashoffset={565 - 565 * parseFloat(parseFloat(waterConsumption) / parseFloat(userGoal)) <= 0 ?
                                0 : (565 - 565 * parseFloat(parseFloat(waterConsumption) / parseFloat(userGoal)))
                            } />
                    </svg>
                    <div class="dashboard-water-consumption-chart-text text_align_center">
                        <input type="number" value={parseInt(waterConsumption)}
                            onChange={(e) => set_water_tracker(!e.target.value || e.target.value < 0 ? 0 : e.target.value)}
                            style={{ width: `${parseInt(waterConsumption).toString().length}ch` }}
                            className='dashboard-water-consumption-chart-inner-circle-input font_family_ovo no_margin' />
                        <p className='no_margin gray_scale_3 font_weight_600'>{'/ ' + userGoal + ' ' + waterConsumptionUnit}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default DailyWater;